import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  ValidatorFn
} from '@angular/forms';
import { EstructuraBase } from '../model-form/estructura-base';
import * as _moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class EstructuraControlService {
  constructor() {}
  validadores: ValidatorFn[];
  toFormGroup(questions: EstructuraBase<any>[]) {
    let group: any = {};

    questions.forEach(question => {
      //alert(JSON.stringify(question));
      let arrayValidator = [];
      if (question.type == 'date') {
        let today = new Date();
        let formatToday = _moment(today).format('YYYY-MM-DD');
        group[question.key] = new FormControl(formatToday);
      } else {
        group[question.key] = new FormControl(question.value || '');
      }

      if (question.required) {
        arrayValidator.push(Validators.required);
      }

      if (question.maxlength > 0) {
        arrayValidator.push(Validators.maxLength(question.maxlength));
      }

      if (question.minlength > 0) {
        arrayValidator.push(Validators.minLength(question.minlength));
      }

      if (question.email == 1) {
        arrayValidator.push(Validators.email);
      }

      if (question.number == 1) {
        arrayValidator.push(Validators.pattern('^[0-9]*$'));
      }

      group[question.key].setValidators(arrayValidator);
      /*group[question.key].setValidators([question.required ? Validators.required : '', (question.maxlength>0) ? Validators.maxLength(question.maxlength) : '']);


      if(question.required && question.maxlength==0 && question.minlength==0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.required]);
      }

      if(question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength)]);
      }


      if(question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength)]);
      }

      if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email]);
      }


      if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
      }

      //END REQUERIDO TRUE

      //COMIENZO REQUERIDO FALSE

      if(!question.required && question.maxlength==0 && question.minlength==0 && question.email==0 && question.number==0){
        //group[question.key].setValidators([Validators.required]);
      }

      if(!question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.maxLength(question.maxlength)]);
      }


      if(!question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength)]);
      }

      if(!question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
        group[question.key].setValidators(Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email]);
      }


      if(!question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
        group[question.key].setValidators([Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
      }

      //END REQUERIDO = FALSE

      //COMIENZO MAXLENGTH >0




      if(question.required && question.maxlength>0 && question.minlength==0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength)]);
      }


      if(question.required && question.maxlength>0 && question.minlength>0 && question.email==0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength)]);
      }

      if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number==0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email]);
      }


      if(question.required && question.maxlength>0 && question.minlength>0 && question.email>0 && question.number>0){
        group[question.key].setValidators([Validators.required, Validators.maxLength(question.maxlength),
          Validators.minLength(question.minlength), Validators.email, Validators.pattern("^[0-9]*$")]);
      }*/

      //group[question.key].setValidators(Validators.maxLength(5));

      /*let validadores:ValidatorFn[];

      if(question.required){
        alert(validadores);
        validadores.push(Validators.required);
      }

      group[question.key] = question.required ? new FormControl(question.value || '', validadores)
        : new FormControl(question.value || '');*/
    });
    return new FormGroup(group);
  }
}
